/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { ITemplates } from "../../store/api/tasks/types";
import { DIALOGOPENFOR } from "../../globals/globals";
import { setConfirmDialog } from "../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../store/hooks";
import { setSelectedTemplate } from "../../store/api/tasks/reducer";
import { useSelector } from "react-redux";
import { selectProfilePermissionsSelector } from "../../store/api/auth/selectors";
import ProfilePermissions from "../../utils/ProfilePermissions";
import { Button } from "../../components/ui/button";
import { Icon } from "../../components/Shared/Icon";

interface ITemplatesProps {
  selectedRow: ITemplates;
  type?: string;
}

const RemoveTemplate: React.FC<ITemplatesProps> = ({ selectedRow = null, type = null }) => {
  const dispatch = useStoreDispatch();
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);
  const isGoldStandard = !!selectedRow?.goldStandard;
  const deleteLabel = isGoldStandard ? "Cannot delete Gold Standard template" : "Delete";
  const removeTemplate = () => {
    if (selectedRow && !isGoldStandard) {
      dispatch(setSelectedTemplate(selectedRow?.templateName || ""));
      if (type === "panel") {
        dispatch(setConfirmDialog(DIALOGOPENFOR.LOCALPANELEMPLATE));
      } else dispatch(setConfirmDialog(DIALOGOPENFOR.DELETETEMPLATE));
    }
  };

  return (
    permissions?.hasOpCodeGroup("manage_topology") && (
      <div className="flex items-center">
            <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0 bg-transparent text-foreground hover:bg-accent hover:text-foreground" aria-label={deleteLabel} title={deleteLabel} onClick={() => removeTemplate()} disabled={isGoldStandard}>
                 <Icon name="delete" size={20} />
            </Button>
        </div>
    )
  );
};

export default RemoveTemplate;
